import { useEffect, useState } from 'react';
import { TimeLogApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { TimeLogDailySum } from '../../../commonTypes/timelog.types';

const useHttpGetDailySumOMX = (projectId: string, from: string, to: string) => {
    const timeLogApi: TimeLogApi = useContainer(TimeLogApi);
    const [data, setData] = useState<TimeLogDailySum[]>([]);
    const [isReady, setIsRady] = useState(false);

    const getSum = (projectIdd: string) => {
        const { exec, abort } = timeLogApi.getDailySumByProject({
            query: { projectId: projectIdd, from: encodeURIComponent(from), to: encodeURIComponent(to) },
            onSuccess: res => {
                setData(res.body);
                setIsRady(true);
            },
            onError: error => error,
        });

        exec();
        return abort;
    };

    useEffect(() => {
        getSum(projectId);
    }, []);

    return { data, isReady, getSum };
};

export default useHttpGetDailySumOMX;
